export default __webpack_public_path__ + "static/media/Welcome Letter.0f8e31b3.svg";